<template lang="pug">
div
  .resource-names(:style="`width: ${timeslotHolderWidth}px`" )
    .resource(
      v-for="(resource, rIndex) in resources"
      :key="rIndex"
      :style="`transform: translateY(${getScrollPosResourceNames}px);`"
      :class="resourceNamesBorderAndShadow"
      )
      .resource-name.flex(:data-test-id="`resource-name-${kebabResourceName(resource.ResourceName)}`")
        .abbr(:style="`background-color: ${resource.ResourceColor}`") {{ getResourceAbbreviation(resource) }}
        .name.flex.flex-none.justify-center.align-center(:title="resource.ResourceName")
          p {{ resource.ResourceName }}
  .resources-data-holder(:style="`width: ${timeslotHolderWidth}px`" )
    .resource(
      v-for="(resource, rIndex) in resources"
      :key="rIndex"
      )
      .timeslots
        .timeslot(
          v-for="(timeslot, tsIndex) in resource.Timeslots" 
          :key="timeslot.StartTime"
          :style="`height: ${getTimeslotHeight(timeslot)}px; margin-top: ${getTimeslotPosition(timeslot)}px;`"
          @drop.prevent="moveBookingCard($event, rIndex, tsIndex)"
          @dragover="checkIfCardCanBeDroped($event, timeslot)"
          @dragenter="updateOverIndexes($event, rIndex, tsIndex)"
          )
          //- disable drag&drop for first version 
          // TimeslotDropPlaceholder(
            :timeslot="timeslot"
            :dragInProgress="dragInProgress"
            :timeslotIndex="tsIndex"
            :resourceIndex="rIndex"
            :timeslotIndexOver="timeslotIndexOver"
            :resourceIndexOver="resourceIndexOver"
            )
          //- BookingCard(
            :timeslotIndex="tsIndex"
            :timeslot="timeslot"
            :resourceIndex="rIndex"
            :resource="resource"
            )
      BookingProductCard(
        v-for="(bookingProduct, bpIndex) in resource.BookingProducts"
        :key="bpIndex"
        :bookingProductIndex="bpIndex"
        :bookingProduct="bookingProduct"
        )
</template>
<script>
import BookingCard from '@/vue/planboard/planboard-calendar/BookingCard.vue'
import BookingProductCard from '@/vue/planboard/planboard-calendar/BookingProductCard.vue'
import TimeslotDropPlaceholder from '@/vue/planboard/planboard-calendar/TimeslotDropPlaceholder.vue'
import { getMinutesFromDuration } from '@/helpers/getTimeFromDuration.js'
import { mapActions, mapGetters } from 'vuex'
import { getTimeslotParts } from '@/vue/planboard/planboard-calendar/planboardCalendarUtil.js'
import toKebab from '@/helpers/toKebab.js'

export default {
  name: 'ResourcesList',
  components: {
    BookingCard,
    TimeslotDropPlaceholder,
    BookingProductCard,
  },
  data() {
    return {
      timeslotIndexOver: 0,
      resourceIndexOver: 0,
    }
  },
  props: {
    resources: Array,
    timeslotHolderWidth: Number,
    scrollPosResourceNames: Number,
  },
  computed: {
    ...mapGetters('planboardModule', ['dragInProgress', 'planboardData']),
    resourceNamesBorderAndShadow() {
      return this.scrollPosResourceNames > 30 ? 'border-and-shadow' : ''
    },
    getScrollPosResourceNames() {
      return this.scrollPosResourceNames > 30 ? this.scrollPosResourceNames - 30 : 0
    },
  },
  methods: {
    ...mapActions('planboardModule', ['moveBookingCardToTimeslot', 'setDragInProgress']),
    getTimeslotHeight(ts) {
      const minutes = getMinutesFromDuration(ts.Duration)
      return getTimeslotParts(minutes) * 60
    },
    getTimeslotPosition(ts) {
      const openingDateTime = new Date(this.planboardData.OpeningDateTime)
      const timeslotStartTime = new Date(ts.StartTime)
      const diff = Math.abs(openingDateTime.getTime() - timeslotStartTime.getTime()) / 3600000 // diff in hours
      return diff * 240 // multiple by the height for 1 hour
    },
    kebabResourceName(resourceName) {
      return toKebab(resourceName)
    },
    getResourceAbbreviation(resource) {
      return resource.ResourceAbbreviation
        ? resource.ResourceAbbreviation
        : resource.ResourceName.substring(0, 2)
    },
    moveBookingCard(e, toResourceIndex, toTimeslotIndex) {
      /*
       * disable drag&drop for first version
       */
      // this.setDragInProgress(false)
      // const bookingProductKey = e.dataTransfer.getData('booking-card-key')
      // const fromResourceIndex = e.dataTransfer.getData('from-resource-index')
      // const fromTimeslotIndex = e.dataTransfer.getData('from-timeslot-index')
      // const data = {
      //   fromResourceIndex,
      //   fromTimeslotIndex,
      //   toResourceIndex,
      //   toTimeslotIndex,
      //   bookingProductKey,
      // }
      // this.moveBookingCardToTimeslot(data)
    },
    updateOverIndexes(e, toResourceIndex, toTimeslotIndex) {
      this.timeslotIndexOver = toTimeslotIndex
      this.resourceIndexOver = toResourceIndex
    },
    checkIfCardCanBeDroped(e, timeslot) {
      if (timeslot.BookedProductKeys === null || timeslot.BookedProductKeys.length === 0)
        e.preventDefault()
    },
  },
}
</script>

<style scoped lang="stylus">
@import '~@v/variables.styl'

.resource-names
  margin-left 90px
  position absolute
  z-index 3
  display flex

  .resource
    border-width 0px 0px 0px 1px
    border-style solid
    border-color grey300
    width 220px
    height 60px
    position relative
    background #EFF3F7
    transition transform 0.3s

    .resource-name
      padding 10px
      position absolute
      width 100%
      z-index 2

    .abbr
      background-color black1
      border-radius 5px
      width 40px
      height 40px
      color #fff
      font-size 16px
      line-height 42px
      font-weight 500
      text-transform uppercase
      text-align center

    .name
      font-size 16px
      font-weight 500
      height 40px
      margin-left 10px
      max-width 150px

      p
        overflow hidden
        text-overflow ellipsis
        display -webkit-box
        line-height 16px
        max-height 32px
        -webkit-line-clamp 2
        -webkit-box-orient vertical
        font-weight 400

.resources-data-holder
  margin-left 90px
  display flex
  position relative
  z-index 2

  .resource
    width 220px
    height 60px
    position relative

    .timeslots
      position absolute
      top 60px
      left 0px

      .timeslot
        background-color transparent
        border-color transparent
        border-width 1px
        border-style solid
        width 217px
        position absolute
        margin-bottom 0px

      > :last-of-type
        border-width 1px 1px 1px 1px

  > :last-child
    border-width 0px 1px 0px 1px

.border-and-shadow
  border-bottom 1px solid grey300
  -webkit-box-shadow 3px 1px 5px 1px grey300
  box-shadow 3px 1px 5px 1px grey300
</style>
